import { SET_PLAN_DETAILS } from '../constants';

export const setPlanDetails = (planDetails) => async (dispatch) => {
  dispatch({ type: SET_PLAN_DETAILS, payload: planDetails });
};
